import { useEffect, useState } from 'react';
import { getConfigKeys, getConfigKeyContentFromDict } from '@/services/config/config-keys-store';

/** Hook generic để lấy value của một config key cụ thể (string). */
export function useKeySetting(key: string, defaultValue = '') {
  const [value, setValue] = useState<string>(defaultValue);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    void getConfigKeys().then((dict) => {
      if (cancelled) return;
      setValue(getConfigKeyContentFromDict(dict, key, defaultValue) ?? defaultValue);
      setLoading(false);
    }).catch(() => {
      if (cancelled) return;
      setValue(defaultValue);
      setLoading(false);
    });

    return () => {
      cancelled = true;
    };
  }, [key, defaultValue]);

  return { value, loading };
}

/** Hook generic để lấy value dạng boolean của một config key. */
export function useKeySettingBool(key: string, defaultValue = false) {
  const { value, loading } = useKeySetting(key, defaultValue ? 'true' : 'false');
  return {
    value: value === 'true',
    loading,
  };
}

// // Lấy value dạng string
// const { value, loading } = useKeySetting('config_setting_login_form', 'false');

// // Lấy value dạng boolean
// const { value, loading } = useKeySettingBool('config_setting_su_dung_quyen_bao_cao_kpis', false);
